import { render, staticRenderFns } from "./Exercise.vue?vue&type=template&id=dd261bf4&scoped=true"
import script from "./Exercise.vue?vue&type=script&lang=js"
export * from "./Exercise.vue?vue&type=script&lang=js"
import style0 from "./Exercise.vue?vue&type=style&index=0&id=dd261bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd261bf4",
  null
  
)

export default component.exports